module.exports = __webpack_public_path__ + "img/thumb-005-09.2242fc83.png";